const actionTypes = {
  FetchOrder: 'FETCH_ORDER',
  OrderUpdated: 'ORDER_UPDATED',
  FetchHalfHalf: 'FETCHED_HALF_HALF',
};

export default actionTypes;
